import { financeChips } from '../financeHeaderCommon';

/*
 * Billing detail config (built-in). Auto-registered by headerConfig.js's
 * ./modules/*.js glob under module key "billing". `header.variant: 'finance'`
 * makes DetailHeaderCard render the finance header design (avatar / icon chips /
 * C2C badge / state-gated buttons / workflow stepper) instead of the default card.
 *
 * Header values are fetched from
 * GET /admin/form-groups?module=billing&id=<timesheetId>&view=detail, resolved
 * against the financeRecords collection (recordKey:"timesheetId"). Buttons come
 * from the seeded Row Actions, gated by the seeded Module Action Rules.
 */
export const billingConfig = {
  module: 'billing',
  tabs: [],
  header: {
    variant: 'finance',
    title: 'candidateName',
    eyebrow: 'designation',
    statusField: 'billing.status',
    chips: financeChips,
  },
};

export default billingConfig;
